import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { GridBaseComponent } from '../../../../../components/common/grid-base/grid-base';
import { PolluxGridConfig } from '../../../../../components/common/pollux-grid-config/pollux-grid-config';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';
import { ProjectsWorkspaceComponent } from '../../workspaces/projects-workspace/projects-workspace.component';
import { projectGridColumns } from './projects-grid-config';
import { AppStorageService } from '../../../../../services/app-storage.service';

/**
 * Projects grid
 */
@Component({
  selector: 'projects-grid',
  templateUrl: './projects-grid.component.html',
  styleUrls: ['./projects-grid.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectsGridComponent extends GridBaseComponent implements OnInit {
  /**
   * A reference to the Kendo grid component
   */
  @ViewChild(GridComponent) kendoGrid: GridComponent;

  /**
   * A reference to the workspace
   */
  public get workspaceReference(): WorkspaceBase {
    return this.workspace;
  }

  /**
   * Gets a list of columns
   * @returns
   */
  public getColumns(): PolluxGridConfig[] {
    return projectGridColumns;
  }

  /**
   * The workspace
   */
  @Input() workspace: ProjectsWorkspaceComponent;

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector, private appStorage: AppStorageService) {
    super(injector, 'projectstd', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * Handle a row selection / deselection event
   * @param _event The event. Can be null!
   * @param item The item. If an item was deselected, it's null
   */
  protected handleRowSelection(_event: any, item: any): void {
    if (_event || item) {
      this.appStorage.setSelectedProject(item);
    }

    this.eventBus.broadcastEvent('project-valuation-infobar-item-changed', {
      mode: 'projectstd',
      item: item,
      itemIdentityProperty: 'Oid'
    });

    if (item) {
      this.workspace.onElementSelected(item);
    }
    else if (_event) {
      this.workspace.onElementDeselected();
    }
    else {
      this.appStorage.setSelectedProject(null);
    }
  }

  /**
   * Handle a doubleclick event
   * @param _event The event. Can be null!
   * @param item The item
   */
  protected handleDoubleClick(_event: any, item: any): void {
    this.workspace.showForm(item.Oid);
  }

  /**
   * Gets the url for loading a paged list
   * @returns The url for loading a paged list
   */
  protected getPagedListEndpoint(): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Projects/list/paged`);
  }

  /**
   * Reset the filters and show all items
   */
  public showAll(): void {
    super.showAll(null);
    this.workspace.onShowAll();
  }

  /**
   * Data loading callback
   * @param data The loaded data
   */
  protected onDataLoaded(data: GridDataResult): void {
    this.workspace.setCounterValue('projectstd', data.total);
  }

  /**
   * Callback to apply CSS classes to grid row
   */
  public rowClassCallback = (context: RowClassArgs) => {
    const rowClasses: any = {
      projectstdRow: true,
      recordStatusInactive: context.dataItem.RecordStatusId === 2
    };

    return rowClasses;
  };

  /**
   * Grid data state change handler
   * @param state Grid state (filters, sorting, grouping, take, skip)
   */
  handleDataStateChange(state: any) {
    this.dataStateChanged(state);
    
    sessionStorage.setItem('filter', JSON.stringify(state));
  }
}
